import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0cca6b9d&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cca6b9d')) {
      api.createRecord('0cca6b9d', component.options)
    } else {
      api.reload('0cca6b9d', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0cca6b9d&", function () {
      api.rerender('0cca6b9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samurai/Index.vue"
export default component.exports